import(/* webpackMode: "eager" */ "/kingsyard-ssr/src/app/(app)/resources/page.js");
